import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
	dateInputContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		justifyContent: 'center',
		'& > :first-child': {
			width: '100%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
		},
		'& label': {
			margin: '0px 8px 0px 0px',
		},
	},
}));

export default useStyles;
